import { Box, Flex, Progress, Text } from '@radix-ui/themes';

export interface StepperProps {
  progress: number;
  step: number;
  totalSteps: number;
}

/** Progress bar + step counter for screen headers. */
export function Stepper({ progress, step, totalSteps }: StepperProps) {
  return (
    <Flex align="center" gap="2">
      <Box width="140px" flexShrink="0">
        <Progress value={progress} size="1" color="red" />
      </Box>
      <Text size="1" style={{ flexShrink: 0 }}>
        {step} / {totalSteps}
      </Text>
    </Flex>
  );
}
